var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconmonstr-check-mark-2","d":"M13.125,28.965,0,16.536l4.07-4.129,8.977,8.452L30.854,2.965,35,7.018Z","transform":"translate(0 -2.965)","fill":"#fff"}));
}

Checkmark.defaultProps = {"width":"35","height":"26","viewBox":"0 0 35 26"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
